import React from "react";
import { Field } from 'redux-form';
import { useSelector } from "react-redux";

import DeletePhoto from "./DeletePhoto";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Spacer from "../../../components/Spacer";
import ProfilePhoto from "../../../components/ProfilePhoto";
import ProfilePhotoUpload from '../../../components/ProfilePhotoUpload';

import style from "./style.module.css";

export default function ProfileCard() {
    const userProfile = useSelector((state) => state.storage.data);
    return (
        userProfile.id !== undefined ? (
            <div className={style.profileCard}>
                <div className={style.colRow}>
                    <div className={style.imageWrap}>
                        <Title className="fontTeko" tag="p" transform="uppercase">PROFILE PICTURE</Title>
                        <Spacer size="16" />
                        <ProfilePhoto size="big" />
                    </div>
                    <div className={style.profileActions}>
                        <Spacer size="32" />
                        <Editor text="Make your mark on WW2HQ!<br>Upload a profile picture to personalise your account." />
                        <Editor text="(File must be less than 1MB)" />
                        <Spacer size="16" />
                        <div className={style.colRow}>
                            <Field name="profile_image" component={ProfilePhotoUpload} type="image" id="profile_image" />
                            {
                                userProfile.image_name !== null && userProfile.image_name !== "" && userProfile.image_name !== undefined && (
                                    <DeletePhoto />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <></>
        )
    )
}